import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { ToastrModule } from 'ngx-toastr';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MultiFileTranslateLoaderFactory } from './core/i18n/multi-file-translate-loader';

// Core components
import { AppComponent } from './app.component';

// Feature components
import { LoginComponent } from './features/auth/login/login.component';
import { HomeComponent } from './features/home/home.component';
import { StudentAccountLockedComponent } from './features/student/components/student-account-locked.component';

// Home feature components
import { HomeNavbarComponent } from './features/home/components/home-navbar/home-navbar.component';
import { HomeHeroComponent } from './features/home/components/home-hero/home-hero.component';
import { HomeVideoDemoComponent } from './features/home/components/home-video-demo/home-video-demo.component';
import { HomeStatsComponent } from './features/home/components/home-stats/home-stats.component';
import { HomeFeaturesComponent } from './features/home/components/home-features/home-features.component';
import { HomeTestimonialsComponent } from './features/home/components/home-testimonials/home-testimonials.component';
import { HomeUserSegmentsComponent } from './features/home/components/home-user-segments/home-user-segments.component';
import { HomeAboutComponent } from './features/home/components/home-about/home-about.component';
import { HomeEducationalOffersComponent } from './features/home/components/home-educational-offers/home-educational-offers.component';
import { HomePricingComponent } from './features/home/components/home-pricing/home-pricing.component';
import { HomeTeamComponent } from './features/home/components/home-team/home-team.component';
import { HomeContentComponent } from './features/home/components/home-content/home-content.component';
import { HomeFinalCtaComponent } from './features/home/components/home-final-cta/home-final-cta.component';
import { HomeFooterComponent } from './features/home/components/home-footer/home-footer.component';

// Shared Material module (aggregates Angular Material imports)
import { MaterialModule } from './shared/material/material.module';

// Interceptors
import { AuthInterceptor } from './core/auth/auth.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    StudentAccountLockedComponent,
    HomeNavbarComponent,
    HomeHeroComponent,
    HomeVideoDemoComponent,
    HomeStatsComponent,
    HomeFeaturesComponent,
    HomeTestimonialsComponent,
    HomeUserSegmentsComponent,
    HomeAboutComponent,
    HomeEducationalOffersComponent,
    HomePricingComponent,
    HomeTeamComponent,
    HomeContentComponent,
    HomeFinalCtaComponent,
    HomeFooterComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: MultiFileTranslateLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      timeOut: 2500,
      closeButton: true,
      progressBar: true,
      preventDuplicates: true
    }),
    AppRoutingModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
